import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="Was im eBook enthalten ist" className="bg-transparent" data-id="element-210" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px'
    }} data-id="element-211" data-mp="1c5grzt88qhxb">
        <div className="text-center" data-id="element-212" data-mp="1c34b7je7ydlu">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-213" data-mp="1zut9dgdq1wap">
            🌸 DAS K-VISUAL MASTERPLAN™ SYSTEM
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-214" data-mp="24tcvphw89a3l">
            📦 Was ist in K-Visual Masterplan™ enthalten?
          </h2>
          <p className="mt-2 text-base text-plum/60" data-id="element-215" data-mp="1vsoham2x97q6">
            6 komplette Bände · 120+ Seiten — Alles, was du brauchst, an einem Ort.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-216" data-mp="fhaoxaqyvxl5">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum-soft" data-id="element-217" data-mp="kby7yu37bzsc">
                {p}
              </span>)}
          </div>
          <p className="mt-8 font-display text-lg font-black uppercase tracking-[0.18em] text-plum-soft" data-id="element-218" data-mp="229q9p5pzlb2">
            📚 Die Methode der 6 Bände
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-219" data-mp="b0lexln1090v">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="group rounded-2xl border border-grape/15 bg-white p-5 transition-colors duration-200 ease-out hover:border-grape/45" data-id="element-220" data-mp="61sbyn5d80ey" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-221" data-mp="wtzgytfxiebi">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lilac-soft font-display text-lg font-black text-grape" data-id="element-222" data-mp="wvai0lhzp7yx">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-223" data-mp="16q2grsnb60va">
                  <span aria-hidden="true" data-id="element-224" data-mp="1bjydysvqzjpe">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-225" data-mp="1kjbolovlyebp">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-226" data-mp="1pjg69i895f3i">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-227" data-mp="1ui18fn72e8ul">
            ✅ Jeder Band enthält
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-228" data-mp="3rb30rtrcrs4q">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-229" data-mp="3qifbeqh8n8">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-230" data-mp="2dejgxsodg1y4" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}